// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noticeIconPopover{position:relative;width:336px;z-index:999}.noticeButton{display:inline-block;cursor:pointer;transition:all .3s}.noticeIconIcon{padding:4px;vertical-align:middle}.noticeIconBadge{font-size:16px}.noticeIconTabs :global .ant-tabs-nav-list{margin:auto}.noticeIconTabs :global .ant-tabs-nav-scroll{text-align:center}.noticeIconTabs :global .ant-tabs-bar{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
